import styled from 'styled-components';

export const StyledBroadcast = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: ${(p) => p.theme.zIndex.broadcast};
`;

export const StyledBar = styled.div`
  position: fixed;
  z-index: ${(p) => p.theme.zIndex.pageFloat};
  left: 0;
  right: 0;
  bottom: 0;
  height: 26px;
  background-color: #3b3b3b;
  border: solid 2px #3b3b3b;
  overflow: hidden;

  .bar-content {
    display: inline-block;
    white-space: nowrap;
  }

  .bar-placeholder {
    width: 2px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }

  .broadcast-item {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    height: 24px;
    line-height: 24px;
    padding: 0 5px;
    border: solid 1px #666;
    border-radius: 4px;
    box-shadow: inset 1px 1px rgba(255, 222, 43, 0.51);
    white-space: nowrap;
    background-color: #fff;

    &:first-child {
      margin-left: 0;
    }

    &.disabled {
      color: unset;
      cursor: default;
    }
  }

  .tit {
    color: #f33;
  }

  .text img {
    position: relative;
    top: -1px;
    width: 22px;
    height: 22px;
    display: inline-block;
    vertical-align: middle;
  }
`;

export const StyledSendAction = styled.div`
  position: relative;
  .btn-action {
    display: inline-block;
    width: 86px;
    height: 30px;
    border-radius: 30px 0 0 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    background-color: #ffc107;
    color: #fff;
    i {
      padding-right: 5px;
    }
    i,
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
`;

export const StyledSendPopup = styled.div`
  position: absolute;
  right: 65px;
  bottom: 40px;
  width: 250px;
  border-radius: 3px;
  padding: 20px;
  position: fixed;
  background: #fff;
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.4);
  z-index: 95000;

  .box-hd {
    padding-bottom: 20px;
    position: relative;

    p {
      color: #2b2b2b;
      height: 20px;
      line-height: 20px;
      font-size: var(--fs-lg);
      font-weight: bold;

      i {
        float: right;
        cursor: pointer;
      }
    }
  }

  .input-text {
    width: 100%;
    height: 80px;
    margin-bottom: 10px;
    padding: 4px;
    border: solid 1px #d8e2e4;
    font-size: var(--fs-md);
    line-height: 1.5;
    box-sizing: border-box;
    resize: none;
    color: #000;
    background-color: #fff;
  }

  .box-ft {
    position: relative;
  }

  .tip-action {
    margin-top: 5px;
    color: #999;
  }

  .tip-count {
    position: absolute;
    right: 40px;
    top: -10px;
    line-height: 40px;
    white-space: nowrap;
    padding-left: 10px;
    vertical-align: baseline;
    font-size: var(--fs-base);
    color: #ccc;
    font-weight: normal;
    text-indent: 0;

    i {
      font-style: normal;
      color: #7c55f9;
    }
  }

  .icon-biaoqing {
    margin-right: 5px;
    &:hover {
      color: #ffc107;
      cursor: pointer;
    }
  }

  .btn-send {
    float: right;
  }
`;

export const StyledEmojiPanel = styled.div`
  position: absolute;
  bottom: 30px;
  right: 0px;
  width: 300px;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  color: #333;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);

  li {
    float: left;
    height: 28px;
    width: 28px;
    border: solid 1px #fff;
    cursor: pointer;
    text-align: center;

    &:hover {
      border-color: #7c55f9;
    }

    img {
      max-height: 28px;
      max-width: 28px;
      vertical-align: middle;
    }
  }
`;
